// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconBuildingSkyscraper, IconCalendar, IconClipboardCheck, IconPictureInPicture, IconForms, IconBorderAll, IconChartDots, IconStairsUp, IconBrandGoogleHome } from '@tabler/icons';
import LocationCitySharpIcon from '@mui/icons-material/LocationCitySharp';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import MapSharpIcon from '@mui/icons-material/MapSharp';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import CategoryIcon from '@mui/icons-material/Category';
import StyleIcon from '@mui/icons-material/Style';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ScienceIcon from '@mui/icons-material/Science';
import AssignmentIcon from '@mui/icons-material/Assignment';


// constant
const icons = {
LocationCitySharpIcon,
PersonAddIcon,
ProductionQuantityLimitsIcon,
IconBuildingSkyscraper,
IconCalendar,
IconClipboardCheck,
IconPictureInPicture,
IconForms,
IconBorderAll,
IconChartDots,
IconStairsUp,
IconBrandGoogleHome,
LocationOnSharpIcon,
MapSharpIcon,
BrandingWatermarkIcon,
CategoryIcon,
StyleIcon,
Inventory2Icon
};

let masterpages = localStorage.getItem('masterpages');
let reportspages = localStorage.getItem('reportspages');
let dailyactivitypages = localStorage.getItem('dailyactivitypages');
let transactionpages = localStorage.getItem('transactionpages');
let productionpages = localStorage.getItem('productionpages');


masterpages = masterpages ? JSON.parse(masterpages) : [];
reportspages = reportspages ? JSON.parse(reportspages) : [];
dailyactivitypages = dailyactivitypages ? JSON.parse(dailyactivitypages) : [];
transactionpages = transactionpages ? JSON.parse(transactionpages) : [];
productionpages = productionpages ? JSON.parse(productionpages) : [];


let masterchildrenpage = Array.isArray(masterpages) ? masterpages.map((item) => {
    var icon = icons.IconClipboardCheck;

    if (item.id === 'State') {
        icon = MapSharpIcon; // Represents a map — suitable for a state
    } else if (item.id === 'District') {
        icon = LocationOnSharpIcon; // A location pin — great for district-level specificity
    } else if (item.id === 'City') {
        icon = LocationCitySharpIcon; // A city skyline — perfect for cities
    }  if (item.id === 'brand') {
        icon = BrandingWatermarkIcon; // Represents branding
    } else if (item.id === 'category') {
        icon = CategoryIcon; // Obvious choice for categories
    } else if (item.id === 'producttype') {
        icon = StyleIcon; // Represents product styles/types
    } else if (item.id === 'product_entry') {
        icon = Inventory2Icon; // Represents inventory/product entry
    } else if (item.id === 'employee_register' || item.id === 'customer_entry' )  {
        icon = icons.PersonAddIcon;
    } else if (item.id === 'monthly_calender' || item.id === 'monthlyplanner' || item.id === 'monthlyplannerA')  {
        icon = icons.IconCalendar;
    } else if (item.id === 'manual_attendance'  )  {
        icon = icons.IconBrandGoogleHome;
    } else if (item.id === 'order_entry' || item.id === 'paymentscreen' )  {
        icon = icons.IconBrandGoogleHome;
    }
              
return {
    id: item.id,
    title: item.title,
    type: item.type,
    url: item.url,
    icon: icon
    };
}) : [];

let reportchildrenpage = Array.isArray(reportspages) ? reportspages.map((item) => {
    var icon = icons.IconClipboardCheck
return {
    id: item.id,
    title: item.title,
    type: item.type,
    url: item.url,
    icon: icon
    };
}) : [];

let dailyactivitychildrenpage = Array.isArray(dailyactivitypages) ? dailyactivitypages.map((item) => {
    var icon = icons.IconClipboardCheck
return {
    id: item.id,
    title: item.title,
    type: item.type,
    url: item.url,
    icon: icon
    };
}) : [];

let transactionschildrenpage = Array.isArray(transactionpages) ? transactionpages.map((item) => {
    var icon = icons.IconClipboardCheck
return {
    id: item.id,
    title: item.title,
    type: item.type,
    url: item.url,
    icon: icon
};
}) : [];
console.log('prodution order Menu screen Allocaiton get from storage',productionpages)

let productionchildrenpage = Array.isArray(productionpages) ? productionpages.map((item) => {
    let icon;

    if (item.id === 'productformula') {
        icon = ScienceIcon;
    } else if (item.id === 'productorder') {
        icon = AssignmentIcon;
    }

return {
    id: item.id,
    title: item.title,
    type: item.type,
    url: item.url,
    icon: icon
    };
}) : [];



const menuGroups = [
        {
            id: 'Master',
            title: <FormattedMessage id="Master" />,
            children: masterchildrenpage
        },
        {
            id: 'Transaction',
            title: <FormattedMessage id="Transaction" />,
            children: transactionschildrenpage
        },
        {
            id: 'Production',
            title: <FormattedMessage id="Production" />,
            children: productionchildrenpage
        },
        {
            id: 'DailyActivity',
            title: <FormattedMessage id="Daily Activity" />,
            children: dailyactivitychildrenpage
        },
        {
            id: 'Reports',
            title: <FormattedMessage id="Reports" />,
            children: reportchildrenpage
        },
]

// filter only page asign Menus
const children = menuGroups
    .filter(group => Array.isArray(group.children) && group.children.length > 0)
    .map(group => ({
        id: group.id,
        title: group.title,
        type: 'collapse',
        icon: icons.IconPictureInPicture,
        children: group.children
    }));

// ==============================|| UI FORMS MENU ITEMS ||============================== //

let forms = {
    id: 'ui-forms',
    icon: icons.IconPictureInPicture,
    type: 'group',
    children
};

export default forms;
